import { fetchChatsDeleteDesktop, TChatsDeleteDesktopResponse } from '../../repositories/chats/v1/chats/delete-desktop';
import { showAlert } from '../../slices/alertSlice';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { TThunkAction } from '../../types/redux/thunk';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';
import { deselectAllChats, toggleChatListPending } from '../chatList/actions';

const DEFAULT_ERROR_MESSAGE = 'Не удалось удалить чаты';

/**
 * Удалить чат(ы)
 */
export const deleteChats = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const {
    chatList: { selectedChats },
  } = getState();
  const { httpApi, logger } = context;

  dispatch(toggleChatListPending(true));

  try {
    const { statusCode, response }: TChatsDeleteDesktopResponse = await fetchChatsDeleteDesktop({
      httpApi,
      parameters: {
        chatIds: selectedChats,
      },
      config: { requestConfig: { withCredentials: true } },
    });

    if (statusCode === 200) {
      dispatch(deselectAllChats());
    } else {
      throw getResponseError({
        domain: EExceptionDomain.Chat,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }
  } catch (error) {
    const exception = getGenericLikeError({
      error,
      domain: EExceptionDomain.Chat,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(exception, {
      microserviceName: 'chats',
      pathApi: '/v1/chats/delete-desktop/',
      parameters: JSON.stringify({ chatIds: selectedChats }),
    });

    dispatch(showAlert({ message: DEFAULT_ERROR_MESSAGE }));
  } finally {
    dispatch(toggleChatListPending(false));
  }
};
